import { createText, createLine } from './helpers';

export const geometricTeal = () => ({
  id: 'geometric-teal',
  name: 'Geometric Teal',
  thumbnail: '/assets/diploma-templates/09_example.webp',
  data: {
    elements: [
      createText({
        text: 'CERTIFICATE',
        left: 147,
        top: 338,
        fontSize: 64,
        fontFamily: 'Cinzel',
        width: 500,
        color: '#2a9d8f',
        fontWeight: 'bold'
      }),
      createText({
        text: 'OF ACHIEVEMENT',
        left: 247,
        top: 409,
        fontSize: 18,
        fontFamily: 'Lato',
        width: 300,
        color: '#333333',
        fontWeight: 'bold'
      }),
      createText({
        text: 'PROUDLY PRESENTED TO',
        left: 247,
        top: 457,
        fontSize: 14,
        fontFamily: 'Lato',
        width: 300,
        color: '#2a9d8f',
        fontStyle: 'italic',
        fontWeight: 'bold'
      }),
      createText({
        text: '{learner_name}',
        left: 47,
        top: 496,
        fontSize: 68,
        fontFamily: 'Allura',
        width: 700,
        color: '#555555'
      }),
      createText({
        text: '{program_description}',
        left: 120,
        top: 591,
        fontSize: 13,
        fontFamily: 'Lato',
        width: 554,
        color: '#999999'
      }),
      createText({
        text: 'This certificate was awarded by:',
        left: 247,
        top: 813,
        fontSize: 15,
        fontFamily: 'Lato',
        width: 300,
        color: '#333333'
      }),
      createText({
        text: 'ROY AUSTIN',
        left: 247,
        top: 883,
        fontSize: 16,
        fontFamily: 'Lato',
        width: 300,
        color: '#2a9d8f',
        fontWeight: 'bold'
      }),
      createLine({ left: 322, top: 911, width: 150, color: '#2a9d8f' }),
      createText({
        text: 'Managing Diretore',
        left: 247,
        top: 913,
        fontSize: 14,
        fontFamily: 'Lato',
        width: 300,
        color: '#666666',
        fontWeight: 'bold'
      })
    ],
    backgroundColor: '#ffffff',
    backgroundImage: {
      url: '/assets/diploma-templates/backgrounds/09_background.svg',
      key: null
    }
  }
});
